import 'whatwg-fetch'
import Promise from 'promise-polyfill'

import { connectionIssues } from './errors'
import AppStore from '../stores/AppStore'
import { buildURL, sendWithAuth } from '../util/api'

if (!window.Promise) {
  window.Promise = Promise
}

export function pinCodeAuthenticate (code, callback) {
  const url = buildURL('/users/pin')

  fetch(url, sendWithAuth({ pin: code }))
    .then((response) => {
      if (response.status === 200) {
        AppStore.data.pinCode.status = 'authenticated'
        AppStore.data.pinCode.code = code
        AppStore.emitChange()
        // Trigger callback (from server)
        if (callback) {
          callback(null)
        }
        connectionIssues(null, 'Connected')
      } else if (response.status === 401) {
        AppStore.data.pinCode.status = 'wrongPin'
        AppStore.emitChange()
        // Trigger callback (from server)
        if (callback) {
          callback(null)
        }
        connectionIssues(null, 'Connected')
      } else {
        throw new Error(`Bad status code: ${response.status}`)
      }
    }, () => {
      throw new Error('Issue connecting to server')
    })
    .catch((error) => {
      AppStore.data.pinCode.status = 'error'
      AppStore.emitChange()
      if (callback) {
        callback(error)
      }
      connectionIssues({ issue: 'Error fetching data', error })
    })
}

export function pinCodeCancel (callback) {
  AppStore.data.pinCode.cancelled = true
  AppStore.emitChange()
  if (callback) { callback() }
}

export function pinCodeReset (callback) {
  AppStore.data.pinCode.status = 'reset'
  AppStore.emitChange()
  if (callback) { callback() }
}

export function pinCodeUnload (callback) {
  AppStore.data.pinCode.status = 'noPin'
  AppStore.data.pinCode.cancelled = false
  AppStore.emitChange()
  if (callback) { callback() }
}

export function pinCodeChange (oldPin, newPin, callback) {
  const url = buildURL('/users/pin/change')

  fetch(url, sendWithAuth({ newPin, oldPin }))
    .then((response) => {
      if (response.status === 200) {
        AppStore.data.pinCode.status = 'changed'
        AppStore.data.user.saved = true
        AppStore.data.pinCode.code = newPin
        AppStore.emitChange()
        // Trigger callback (from server)
        if (callback) {
          callback(null)
        }
        connectionIssues(null, 'Connected')
      } else if (response.status === 401) {
        AppStore.data.pinCode.status = 'wrongPin'
        AppStore.data.user.saved = 'error'
        AppStore.emitChange()
        // Trigger callback (from server)
        if (callback) {
          callback(null)
        }
        connectionIssues(null, 'Connected')
      } else {
        throw new Error(`Bad status code: ${response.status}`)
      }
    }, () => {
      throw new Error('Issue connecting to server')
    })
    .catch((error) => {
      AppStore.data.pinCode.status = 'error'
      AppStore.data.user.saved = 'error'
      AppStore.emitChange()
      if (callback) {
        callback(error)
      }
      connectionIssues({ issue: 'Error fetching data', error })
    })
}
